import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import Slider from 'react-slick';
import styles from './style.module.scss';
import '../../styles/_slick.scss';
import '../../styles/_slick_chevron.scss';
/**
 * A component showing a slider of images
 *
 * @param {React.Node}  children  The children slides
 **/

var ImageSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageSlider, _React$Component);

  function ImageSlider(props) {
    var _this;

    _classCallCheck(this, ImageSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageSlider).call(this, props));

    _this.updateWindowDimensions = function () {
      _this.setState(_objectSpread({}, _this.state, {
        width: window.innerWidth
      }));
    };

    _this.renderChildren = function (children) {
      return React.Children.map(children, function (child, index) {
        return React.createElement("div", {
          className: styles.imageWrapper
        }, React.cloneElement(child, {
          className: styles.image
        }));
      });
    };

    _this.state = {
      width: window.innerWidth,
      setting: {
        slidesToShow: window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 4
      }
    };
    return _this;
  }

  _createClass(ImageSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      return styles.slider + this.props.multiline ? " ".concat(styles.multiline) : '';
    }
  }, {
    key: "getSlidesToShow",
    value: function getSlidesToShow() {
      if (this.state.width < 768) {
        return 1;
      }

      if (!this.props.multiline && this.state.width < 1024) {
        return 2;
      }

      return 4;
    }
  }, {
    key: "render",
    value: function render() {
      var settings = _objectSpread({
        slidesToScroll: 1,
        infinite: true,
        autoplay: this.props.autoplay ? this.props.autoplay : false,
        slidesToShow: this.getSlidesToShow()
      }, this.props.multiline ? {
        rows: 2,
        slidesPerRow: 1
      } : {});

      return React.createElement(Slider, Object.assign({
        className: this.getClassName()
      }, settings), this.renderChildren(this.props.children));
    }
  }]);

  return ImageSlider;
}(React.Component);
/**
 * It's just am image Tag really...
 *
 **/


var Element = function Element(props) {
  return React.createElement("img", Object.assign({
    alt: ""
  }, props));
};

ImageSlider.Element = Element;
export { ImageSlider };
export default ImageSlider;